<script lang="ts">
  import { yyyy, zzzz } from "../store.svelte";
  import Choice from "./Choice.svelte";
  import NameUpload from "./NameUpload.svelte";
  import ChronicleUpload from "./ChronicleUpload.svelte";
  import Configure from "./Configure.svelte";
  import { onMount } from "svelte";

  yyyy.createNewLiveWire = {};
  yyyy.createNewLiveWire.choice = false;
  yyyy.createNewLiveWire.name = false;
  yyyy.createNewLiveWire.upload = false;
  yyyy.createNewLiveWire.layers = [];

  onMount(() => {
    if (!yyyy.sesh.logtoken) {
      zzzz.emit("goto", "/");
      return;
    }
  });
</script>

{#if !yyyy.createNewLiveWire.choice}
  <Choice />
{/if}

{#if yyyy.createNewLiveWire.choice === "old"}
  <ChronicleUpload />
{/if}

{#if yyyy.createNewLiveWire.choice === "new" && (yyyy.createNewLiveWire.name || yyyy.createNewLiveWire.upload)}
  <NameUpload />
{/if}

{#if yyyy.createNewLiveWire.choice === "new" && yyyy.createNewLiveWire.layers && yyyy.createNewLiveWire.layers.length > 0 && !yyyy.createNewLiveWire.name && !yyyy.createNewLiveWire.upload}
  <Configure />
{/if}

<style>
  /* Styles are handled by child components */
</style>
